import { ConsumableGroup } from '../../../common/interfaces/dtos/ConsumableGroup';
import { ITenderGroup } from '../../../common/interfaces/dtos/ITenderGroup';
import { emeraldRequest } from '../../../common/api/emerald-request';
import { AxiosRequestConfig } from 'axios';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';

export const pluMenuConfigurationLookup = async (
  localTimeStamp?: string,
): Promise<ConsumableGroup> => {
  const axiosConfig: AxiosRequestConfig = {
    url: '/menu/plu-menu',
    method: 'GET',
    params: {
      timestamp: localTimeStamp,
    },
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };

  return await emeraldRequest<ConsumableGroup>(emeraldRequestParams);
};

export const tenderMenuConfigurationLookup = async (
  touchpointType: string,
  tenderIds: string[],
): Promise<ITenderGroup[]> => {
  const axiosConfig: AxiosRequestConfig = {
    method: 'POST',
    url: '/menu/tenders',
    params: {
      touchpointType,
    },
    data: tenderIds,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };

  return await emeraldRequest(emeraldRequestParams);
};
